var exports = {
  "kL": "container__zQ9Aux",
  "tJ": "metadataContainer__Q9Q3mA",
  "xe": "metadataContent__Eu7S72",
  "iz": "messageBubble__O0m_7x",
  "mI": "meta__1I-og6",
  "dF": "metaSmall__PcMe3h",
  "H": "avatarContainer__xMUOdA",
  "Dy": "agentMentionText__niOIkf",
};

module.exports = exports;
